export * from "./PatientExercisesTable.async";
export * from "./patientExercisesTable.interface";
